import axios from 'axios';
import { BASE_URL } from './apiconfig';

/**
 * V1 / Coldfire firmware: the legacy catalog and pushes through the legacy SpaServer.
 * Never mix with the V2 catalog in firmware.api.ts: the version schemes differ and a V2
 * version pushed to a V1 pack is an incident. Backend: docs/v1-firmware-update.md.
 */

/** Firmware components a V1 spa takes: the Yoctub's three boards, or a Coldfire pack. */
export type V1FirmwarePlatform = 'yocto' | 'lpc' | 'spaboy' | 'cf';
export type V1FirmwareChannel = 'public' | 'dev';

export interface V1Firmware {
  version: string;
  type: V1FirmwarePlatform;
  version_code: number;
  is_latest: boolean;
}

export const fetchV1FirmwareApi = async (token: string | null, channel: V1FirmwareChannel): Promise<V1Firmware[]> => {
  const { data } = await axios.get(`${BASE_URL}/v1-firmware/available`, {
    params: { channel },
    headers: { Authorization: `Bearer ${token}` },
  });
  return data.data.data;
};

/** Same response shape as bulkUpgradeFirmwareApi, so FirmwareUpdateModal renders either. */
export const upgradeV1FirmwareApi = async (
  token: string | null,
  body: { spa_guids: string[]; platform: string; version: string; channel: V1FirmwareChannel },
) => {
  const { data } = await axios.post(`${BASE_URL}/v1-firmware/upgrade`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};
